export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20macro%20photograph%20of%20precision-engineered%20metallic%20surface%20with%20subtle%20geometric%20patterns%20and%20soft%20natural%20gradients%2C%20warm%20muted%20charcoal%20and%20bronze%20tones%20with%20delicate%20amber%20highlights%2C%20industrial%20material%20texture%20showing%20brushed%20grain%20and%20micro-perforations%2C%20architectural%20detail%20study%2C%20diffused%20natural%20lighting%20from%20above%2C%20extremely%20shallow%20depth%20of%20field%2C%20no%20text%20no%20people%20no%20logos%2C%20minimalist%20editorial%20composition&width=1800&height=1200&seq=hero-bg-feman&orientation=landscape"
        alt="Abstract precision-engineered metallic surface with warm charcoal and bronze tones"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/50"></div>

      <div className="relative z-10 w-full px-8 md:px-16 lg:px-24 xl:px-32">
        <div className="max-w-4xl">
          <div className="mb-6">
            <span className="inline-block text-xs tracking-[0.25em] uppercase text-white/60 font-medium">
              Engineering Excellence
            </span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-heading font-semibold text-white leading-[1.08] tracking-tight mb-8">
            FEMAN SYSTEMS d.o.o.
          </h1>

          <div className="max-w-2xl">
            <p className="text-lg md:text-xl text-white/80 font-light leading-relaxed">
              A professional engineering team focused on designing and developing modern digital software solutions for the iOS platform and related technologies.
            </p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-8 md:left-16 lg:left-24 xl:left-32 z-10">
        <div className="flex items-center gap-2 text-white/50 text-sm">
          <div className="w-10 h-px bg-white/30"></div>
          <span className="font-light tracking-wide">Scroll</span>
        </div>
      </div>
    </section>
  );
}